import { Flexbox } from "st-app";
import { GroupAction } from "./GroupAction";
import { Group } from "./Group";
import styles from '../sis-role-dashboard.module.css'
import { UserRecentHistory } from "./UserRecentHistory";
import { For, createMemo } from "solid-js";
import { requireRoleDashboardContext } from "../RoleDashboardContext";
import { StaffRole } from "../../../api";

export function SupportAgentDashboard() {
    const ctx = requireRoleDashboardContext();

    const tasks = ctx.sortedActions([
        'CRC.AssignedTickets',
        'CRC.ManageWorkOrder',
        'CRC.TicketAdd',
        'CRC.Tickets',
        'CRC.SupportAssist',
    ]);

    const shortcuts = createMemo(() => {
        const addShortcuts = ctx.configuration()
            ?.additionalShortcuts
            .filter(desc => desc.role === StaffRole.SupportAgent)
            .map(desc => desc.ID!);

        return ctx.sortedActions([
            'CRC.ETN',
        ].concat(addShortcuts ?? []));
    });

    return <Flexbox dir="horizontal" auto class={styles['dashboard-content']} >
        <Flexbox dir="vertical" auto>
            <Group title="Tasks" icon="fas fa-headset" color="--header-teal">
                <For each={tasks}>{id => <GroupAction id={id} />}</For>
            </Group>

            <Group title="Shortcuts" icon="fas fa-bolt" color="--header-blue">
                <For each={shortcuts()}>{id => <GroupAction id={id} allowDetach />}</For>
            </Group>

            <Flexbox.Item auto />
        </Flexbox>
        <UserRecentHistory />
    </Flexbox>
}
